import { BalanceSolicitationAnalysisResponse } from "@/models/consignado/balanceSolicitation.model";
import { axiosConsignadoInstance } from "../axiosInstance";
import { CreditEngineReportResponseData } from "@/models/consignado/report-data.model";

export const getCreditEngineBalanceSolicitationReport = async (
  id: string
): Promise<BalanceSolicitationAnalysisResponse> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/credit-engine-report/balance-solicitation/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao obter a análise de crédito:", error);
    throw error;
  }
};

export const getCreditEngineProposalReport = async (
  id: string
): Promise<CreditEngineReportResponseData> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/credit-engine-report/proposal/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao obter a análise de crédito:", error);
    throw error;
  }
};

